// extracted by css-extract-rspack-plugin
export default {"container":"PinnedIssuesStrip-module__container__TmWOd","area":"PinnedIssuesStrip-module__area__r5iB7"};